




















































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class VideoTrimmerDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop({ type: String, required: true }) videoSrc!: string;
  @Prop({ type: String }) initialStart!: string | null;
  @Prop({ type: String }) initialEnd!: string | null;

  startTime: string = "00:00:00.000";
  endTime: string = "00:00:00.000";
  duration: number = 0;

  @Watch("syncedShowDialog")
  onShowDialogChanged(val: boolean) {
    if (val) {
      this.startTime = this.initialStart || "00:00:00.000";
      this.endTime = this.initialEnd || "00:00:00.000";
      
      this.$nextTick(() => {
        const video = this.$refs.trimVideo as HTMLVideoElement;
        if (video && video.readyState >= 1) { // metadata loaded
          this.onLoadedMetadata();
        }
      });
    }
  }

  onLoadedMetadata() {
    const video = this.$refs.trimVideo as HTMLVideoElement;
    if (video) {
      this.duration = video.duration;
      if (!this.initialEnd || this.initialEnd == "00:00:00.000") {
        this.endTime = this.formatTime(video.duration);
      }
    }
  }

  get durationFormatted(): string {
    return this.formatTime(this.duration);
  }

  get selectedLengthFormatted(): string {
    // console.log("Calculating selected length:", this.startTime, this.endTime);
    const start = this.parseTime(this.startTime);
    // console.log("Parsed start time:", start);
    const end = this.parseTime(this.endTime);
    // console.log("Parsed end time:", end);
    const formattedLength = this.formatTime(Math.max(0, end - start));
    // console.log("Formatted selected length:", formattedLength);
    return formattedLength;
  }

  formatTime(seconds: number): string {
    if (isNaN(seconds) || seconds < 0) return "00:00:00.000";
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds % 1) * 1000);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
  }

  parseTime(timeStr: string): number {
    if (!timeStr) return 0;
    try {
      // Handle potential .NET TimeSpan format with 7 decimal places (e.g. 00:00:02.5060000)
      const parts = timeStr.split(':');
      if (parts.length !== 3) return 0;
      const hours = parseFloat(parts[0]);
      const minutes = parseFloat(parts[1]);
      const lastParts = parts[2].split('.');
      const seconds = parseFloat(lastParts[0]);
      
      let ms = 0;
      if (lastParts[1]) {
        // Take the decimal part and treat it as a fraction of a second
        // e.g. "5060000" becomes 0.5060000 seconds
        ms = parseFloat("0." + lastParts[1]) * 1000;
      }
      
      return hours * 3600 + minutes * 60 + seconds + ms / 1000;
    } catch (e) {
      return 0;
    }
  }

  setStartFromCurrent() {
    const video = this.$refs.trimVideo as HTMLVideoElement;
    if (video) {
      this.startTime = this.formatTime(video.currentTime);
    }
  }

  setEndFromCurrent() {
    const video = this.$refs.trimVideo as HTMLVideoElement;
    if (video) {
      this.endTime = this.formatTime(video.currentTime);
    }
  }

  previewTrim() {
    const video = this.$refs.trimVideo as HTMLVideoElement;
    if (video) {
      const startSec = this.parseTime(this.startTime);
      const endSec = this.parseTime(this.endTime);
      
      video.currentTime = startSec;
      video.play();
      
      const checkEnd = () => {
        if (video.currentTime >= endSec) {
          video.pause();
          video.removeEventListener('timeupdate', checkEnd);
        }
      };
      
      // Remove any existing listener first to be safe
      video.removeEventListener('timeupdate', checkEnd);
      video.addEventListener('timeupdate', checkEnd);
    }
  }

  onCancel() {
    this.syncedShowDialog = false;
  }

  onSave() {
    this.$emit("save:trim", { start: this.startTime, end: this.endTime });
    this.syncedShowDialog = false;
  }
}
